module.exports = __webpack_public_path__ + "img/Delivery-Truck-Fast.1c01f33b.svg";